const CalendarEventColor = {
  RED: "red",
  TEAL: "teal",
  BLUE: "blue",
  PURPLE: "purple",
  GOLDEN: "golden",
  GREEN: "green",
  GRAY: "gray",
};

const CALENDAR_COLORS = {
  [CalendarEventColor.RED]: {
    light: "#fcf0ee",
    dark: "#F57361",
    contrast: "#C63E2B",
  },
  [CalendarEventColor.TEAL]: {
    light: "#f3f9fc",
    dark: "#46bbc4",
    contrast: "#46bbc4",
  },
  [CalendarEventColor.BLUE]: {
    light: "#E6ECF8",
    dark: "#5B85D2",
    contrast: "#2A4EA1",
  },
  [CalendarEventColor.PURPLE]: {
    light: "#F3F1FC",
    dark: "#a18fe7",
    contrast: "#8173bb",
  },
  [CalendarEventColor.GOLDEN]: {
    light: "#fcf4e9",
    dark: "#f4ba67",
    contrast: "#a65b10",
  },
  [CalendarEventColor.GREEN]: {
    light: "#EAF3E0",
    dark: "#A5CD7F",
    contrast: "#46822B",
  },
  [CalendarEventColor.GRAY]: {
    light: "#F7F7F7",
    dark: "#AAAAAA",
    contrast: "#717171",
  },
};
export const calendarAdaptor = (events) => {
  return (events || []).map((event, index) => {
    const { start, end } = getRange(event);
    const color_code = event.color_code || CalendarEventColor.GRAY;
    let backgroundColor;
    let borderColor;
    let textColor;

    backgroundColor = CALENDAR_COLORS[color_code]?.light || "white";
    borderColor = CALENDAR_COLORS[color_code]?.dark || "black";
    textColor = CALENDAR_COLORS[color_code]?.contrast || "black";

    return {
      id: event.event_id,
      title: event.title,
      start: start,
      end: end,
      backgroundColor,
      borderColor,
      textColor,
      allDay: event.is_all_day,
      editable: event.is_editable,
      extendedProps: {
        source_event: event,
      },
    };
  });
};

const getRange = (event) => {
  let start, end;
  let start_date = new Date(event.event_date);
  let end_date = new Date(event.event_date);
  const start_time = event.start_time;
  const end_time = event.end_time;

  if (event.is_all_day) {
    end_date.setHours(end_date.getHours() + 23, end_date.getMinutes() + 59, 0, 0);

    return {
      start: start_date.toISOString(),
      end: end_date.toISOString(),
    };
  }

  if (start_time) {
    const [start_hours, start_minutes] = start_time.split(":").map(Number);
    start_date.setHours(start_date.getHours() + start_hours, start_date.getMinutes() + start_minutes, 0, 0);
  }
  if (end_time) {
    const [end_hours, end_minutes] = end_time.split(":").map(Number);
    end_date.setHours(end_date.getHours() + end_hours, end_date.getMinutes() + end_minutes, 0, 0);
  }

  start = start_date.toISOString();
  end = end_date.toISOString();

  return { start, end };
};
